var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonCloseFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C5.15 0.5 0.5 5.15 0.5 11C0.5 16.85 5.15 21.5 11 21.5C16.85 21.5 21.5 16.85 21.5 11C21.5 5.15 16.85 0.5 11 0.5ZM15.65 15.65C15.3186 15.9814 14.7814 15.9814 14.45 15.65L11 12.2L7.55 15.65C7.21863 15.9814 6.68137 15.9814 6.35 15.65C6.01863 15.3186 6.01863 14.7814 6.35 14.45L9.8 11L6.35 7.55C6.01863 7.21863 6.01863 6.68137 6.35 6.35C6.68137 6.01863 7.21863 6.01863 7.55 6.35L11 9.8L14.45 6.35C14.7814 6.01863 15.3186 6.01863 15.65 6.35C15.9814 6.68137 15.9814 7.21863 15.65 7.55L12.2 11L15.65 14.45C15.9814 14.7814 15.9814 15.3186 15.65 15.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCloseFilled);
export default __webpack_public_path__ + "static/media/carbon_close-filled.30722de0f30450965599fd50230996a1.svg";
export { ForwardRef as ReactComponent };